import { isMobile } from "@sky-it-livedata/common-web-app-utils";

export const CSS_PREFIX = 'ftbl__';
export const TAB_ITEM_CLASS_PREFIX = 'tab-item--';
export const ACTIVE_TAB_CLASS_PREFIX = 'active-tab--';
export const TAB_SWITCH_CONTENT_ID = 'tabs-switch__content';
export const TABS_MENU_CLASSNAME = 'tabs-menu';

export const LOCAL_NAV_EL_SELECTOR = '.j-local-nav';
export const SECTION_NAV_EL_SELECTOR = '.j-section-nav';
export const HERO_SLIM_IS_VISIBLE = 'isVisible';
export const HERO_SLIM_HOOK = '.j-hero-lmp-slim';
export const HERO_HOOK = '.j-intro';

export const getActiveTab = (): Element | null => {
  const tabsMenuElement = document.querySelector(`.${CSS_PREFIX}${TABS_MENU_CLASSNAME}`);
  if (!tabsMenuElement) {
    return null;
  }
  const activeTabAttribute = tabsMenuElement.getAttribute('data-state') ?? '';
  const activeTab = activeTabAttribute.replace(ACTIVE_TAB_CLASS_PREFIX, TAB_ITEM_CLASS_PREFIX);
  return activeTab.includes(TAB_ITEM_CLASS_PREFIX) ? document.querySelector(`#${CSS_PREFIX}${activeTab}`) : null;
};

/**
 * Scrolls passed tab into viewport
 */
export const activeTabScrollIntoView = () => {
  const activeTabElement: Element | null = getActiveTab();

  if (activeTabElement) {
    tabScrollIntoView(activeTabElement, 'auto');
    window.scrollTo({ top: 0 });
  }
};

export const tabScrollIntoView = (tab: Element, behavior: ScrollBehavior = 'smooth'): void => {
  if (isMobile() && tab && typeof tab.scrollIntoView === 'function') {
    tab.scrollIntoView({
      behavior,
      block: 'nearest',
      inline: 'center',
    });
  }
};